(function () {
  'use strict';

  function initStickyBar(bar) {
    if (!bar || bar.dataset.celzoirInitialized === 'true') return;

    var section = document.getElementById(bar.dataset.productSection);
    var stickyButton = bar.querySelector('[data-celzoir-sticky-button]');
    var mainButton = section && section.querySelector('.add-to-cart');

    if (!section || !stickyButton || !mainButton) return;
    bar.dataset.celzoirInitialized = 'true';

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    stickyButton.addEventListener('click', function () {
      var header = section.querySelector('.product-block--header');
      var price = section.querySelector('.product-block--price');
      var viewportSpace = Math.max(0, window.innerHeight - 150);
      var buttonBottom = window.scrollY + mainButton.getBoundingClientRect().bottom;
      var preferredStart = header || price;

      if (preferredStart) {
        var preferredTop = window.scrollY + preferredStart.getBoundingClientRect().top - 16;
        if (buttonBottom - preferredTop > viewportSpace && price) {
          preferredStart = price;
        }
      }

      var startTop = preferredStart
        ? window.scrollY + preferredStart.getBoundingClientRect().top - 16
        : buttonBottom - viewportSpace;
      var targetTop = Math.max(0, Math.min(startTop, buttonBottom - viewportSpace));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: targetTop,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });

    var visibilityFramePending = false;

    function updateVisibility() {
      visibilityFramePending = false;
      setVisible(mainButton.getBoundingClientRect().bottom < 0);
    }

    function requestVisibilityUpdate() {
      if (visibilityFramePending) return;
      visibilityFramePending = true;
      window.requestAnimationFrame(updateVisibility);
    }

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    requestVisibilityUpdate();
  }

  function updatePriceBadges(variant) {
    document.querySelectorAll('[data-celzoir-price-badge]').forEach(function (badge) {
      var compareAtPrice = variant && Number(variant.compare_at_price);
      var price = variant && Number(variant.price);
      var isOnSale = compareAtPrice > price;

      badge.classList.toggle('hide', !isOnSale);
      badge.setAttribute('aria-hidden', isOnSale ? 'false' : 'true');

      if (isOnSale) {
        var discount = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
        var value = badge.querySelector('[data-celzoir-price-badge-value]');

        if (value) value.textContent = '-' + discount + (badge.dataset.percentToken || '%');
        badge.setAttribute('aria-label', badge.dataset.labelTemplate.replace('__DISCOUNT__', discount));
      }
    });
  }

  function updateOffers(variant) {
    document.querySelectorAll('[data-celzoir-offer]').forEach(function (offer) {
      var compareAtPrice = variant && Number(variant.compare_at_price);
      var price = variant && Number(variant.price);
      var isOnSale = compareAtPrice > price;
      var message = offer.querySelector('[data-celzoir-offer-message]');

      offer.classList.toggle('hide', !isOnSale);
      offer.setAttribute('aria-hidden', isOnSale ? 'false' : 'true');

      if (isOnSale && message) {
        var discount = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
        message.textContent = offer.dataset.labelTemplate.replace('__DISCOUNT__', discount);
      }
    });
  }

  function initStoreAvailability(widget) {
    if (!widget || widget.dataset.celzoirStoreInitialized === 'true') return;

    var modal = widget.querySelector('[data-celzoir-store-modal]');
    var openButton = widget.querySelector('[data-celzoir-store-open]');
    var closeButton = widget.querySelector('[data-celzoir-store-close]');
    var countrySelect = widget.querySelector('[data-celzoir-store-country]');
    var citySelect = widget.querySelector('[data-celzoir-store-city]');
    var cityLabel = widget.querySelector('[data-celzoir-store-city-label]');
    var cityResult = widget.querySelector('[data-celzoir-store-city-result]');

    if (!modal || !openButton || !closeButton) return;
    widget.dataset.celzoirStoreInitialized = 'true';

    function openModal() {
      modal.hidden = false;
      document.body.classList.add('celzoir-store-modal-open');
      closeButton.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('celzoir-store-modal-open');
      openButton.focus();
    }

    openButton.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        countrySelect.form.submit();
      });
    }

    if (citySelect && cityResult) {
      function updateCity() {
        var city = citySelect.value;
        cityResult.textContent = cityResult.dataset.labelTemplate.replace('__CITY__', city);
        if (cityLabel) cityLabel.textContent = city;
      }

      citySelect.addEventListener('change', updateCity);
      updateCity();
    }
  }

  function init() {
    document.querySelectorAll('[data-celzoir-sticky-atc]').forEach(initStickyBar);
    document.querySelectorAll('[data-celzoir-store-availability]').forEach(initStoreAvailability);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    updatePriceBadges(variant);
    updateOffers(variant);
  });
})();
